import { render, staticRenderFns } from "./GasMetricTable.vue?vue&type=template&id=fc00ce82&scoped=true&"
import script from "./GasMetricTable.vue?vue&type=script&lang=js&"
export * from "./GasMetricTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc00ce82",
  null
  
)

export default component.exports